<!--div class="wh-toolbox" [custom_draggable]="draggable" >
    <div class="wh-toolbox-header" >
        <mat-icon class="wh-toolbox-toggle-icon-drag" (mouseup)="mouseUp($event)" (mousedown)="mouseDown($event)">drag_indicator</mat-icon>
        <div class="wh-toolbox-header-title">{{'wh.toolbox'|translateTA}}</div>
        <mat-icon class="wh-toolbox-toggle-icon" (click)="close()">{{closed?'keyboard_arrow_down':'close'}}</mat-icon>
    </div>
    <div class="wh-toolbox-body"  [ngClass]="{'wh-toolbox-closed': closed, 'wh-toolbox-opened':!closed}" [ngStyle]="{'max-height': maxHeight+'px;'}" >  
        <input class="wh-toolbox-filter" [placeholder]="'wh.filter'|translateTA">
        <div class="wh-toolbox-scrollable"  >
            <div class="wh-toolbox-group-title">{{'wh.step.artefacts'|translateTA}}</div>
            <div class="wh-toolbox-itens">
                @for ( item of artefacts; track item){
                    <div class="wh-toolbox-item" fExternalItem [fData]="item">
                        <mat-icon class="wh-toolbox-item-icon" *ngIf="!item.svg">{{item.icon}}</mat-icon>
                        <mat-icon class="wh-toolbox-item-icon" *ngIf="item.svg" [svgIcon]="item.icon"></mat-icon>
                        <div class="wh-toolbox-item-text">{{item.text|translateTA}}</div>
                    </div>
                }
            </div>
        </div>
        <div class="wh-toolbox-scrollable" >
            <div class="wh-toolbox-group-title">{{'wh.step.connectors'|translateTA}}</div>
            <div class="wh-toolbox-itens">
                @for ( item of connectors; track item){
                    <div class="wh-toolbox-item"  fExternalItem  [fData]="item">
                        <mat-icon class="wh-toolbox-item-icon" *ngIf="!item.svg">{{item.icon}}</mat-icon>
                        <mat-icon class="wh-toolbox-item-icon" *ngIf="item.svg" [svgIcon]="item.icon"></mat-icon>
                        <div class="wh-toolbox-item-text">{{item.text|translateTA}}</div>
                    </div>
                }
            </div>
        </div>
    </div>
</div-->


    <ul nz-menu nzTheme="light" nzMode="inline">
        <li nz-submenu nzTitle="{{'wh.step.artefacts'|translateTA}}" nzIcon="appstore">
            <ul>
                <div class="workflow-tool-wrapper" nz-flex [nzGap]="'middle'" [nzWrap]="'wrap'">
                @for ( item of artefacts; track item){
                
                    <div class="workflow-tool-item" fExternalItem [fData]="item"  [nz-tooltip]="item.text|translateTA">
                        <mat-icon  *ngIf="!item.svg">{{item.icon}}</mat-icon>
                        <mat-icon *ngIf="item.svg" [svgIcon]="item.icon"></mat-icon>
                        <!--div class="workflow-tool-item-text">{{item.text|translateTA}}</div-->
                    </div>
                }
                </div>
            </ul>
        </li>


        <li nz-submenu nzTitle="{{'wh.step.connectors'|translateTA}}" nzIcon="sliders">
            <ul>
                <div class="workflow-tool-wrapper" nz-flex [nzGap]="'middle'" [nzWrap]="'wrap'">
                @for ( item of connectors; track item){
                
                    <div class="workflow-tool-item" fExternalItem [fData]="item"  [nz-tooltip]="item.text|translateTA">
                        <mat-icon  *ngIf="!item.svg">{{item.icon}}</mat-icon>
                        <mat-icon *ngIf="item.svg" [svgIcon]="item.icon"></mat-icon>
                        <!--div class="workflow-tool-item-text"></div-->
                    </div>
                
                }
                </div>
            </ul>
        </li>

        <li nz-submenu nzTitle="{{'wh.step.template'|translateTA}}" nzIcon="branches">
            <ul>
                <!--div class="workflow-tool-wrapper" nz-flex [nzGap]="'middle'" [nzWrap]="'wrap'">
                @for ( item of artefacts; track item){
                
                    <div class="workflow-tool-item" fExternalItem [fData]="item"  [nz-tooltip]="item.text|translateTA">
                        <mat-icon  *ngIf="!item.svg">{{item.icon}}</mat-icon>
                        <mat-icon *ngIf="item.svg" [svgIcon]="item.icon"></mat-icon>
                        <div class="workflow-tool-item-text">{{item.text|translateTA}}</div>
                    </div>
                
                }
                </div> -->
            </ul>
        </li>
  
  